import { buildQuery, type OdataFilters } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/messages";
const STEP = 10;

const messagesQuery = {
    top: STEP,
    orderBy: ["createdAt desc", "id desc"],
};

const getChatMessagesOld = ({ queryFilter, ...params }: OdataFilters, chatId: number) => {
    const qp = new URLSearchParams(queryFilter as URLSearchParams);
    const query = buildQuery({ ...messagesQuery, ...params }).substr(1);
    const queryString = [qp.toString(), query].filter((item) => item.length).join("&");
    return request(`${resource}/getChatMessages/${chatId}?${queryString}`, { method: "GET" });
};

const getChatMessages = ({ queryFilter, ...params }: OdataFilters, chatId: number) => {
    const qp = new URLSearchParams(queryFilter as URLSearchParams);
    const query = buildQuery({ ...messagesQuery, ...params }).substr(1);
    const queryString = [qp.toString(), query].filter((item) => item.length).join("&");
    return request(`${resource}/getChatMessages?chatId=${chatId}&${queryString}`, { method: "GET" });
};
const getParticipant = (id: number) => request(`${resource}/getParticipantsInChat/${id}`, { method: "GET" });
const sendMessage = (params: {}) => request(`${resource}/sendMessage`, body(params));
const sendFile = (params: {}) => request(`${resource}/sendFileMessage`, params);
const getInfo = (id: number) => request(`${resource}/getInfo/${id}`, { method: "GET" });
const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));
const restore = (params: {}) => request(`${resource}/restore`, body(params));
const addUserToChat = (params: {}) => alertRequest(`${resource}/addUserToChat`, body(params));
const deleteUserFromChat = (params: {}) => alertRequest(`${resource}/deleteUserFromChat`, body(params));
const addChatToFavorites = (params: {}) => request(`${resource}/addChatToFavorites`, body(params));
const removeChatFromFavorites = (params: {}) => request(`${resource}/removeChatFromFavorites`, body(params));
const leaveChat = (params: {}) => request(`${resource}/leaveChat`, body(params));
const addGroupUsersToDriverChat = (params: {}) => request(`${resource}/addGroupUsersToDriverChat`, body(params));
const deleteGroupUsersFromDriverChat = (params: {}) =>
    request(`${resource}/deleteGroupUsersFromDriverChat`, body(params));

export {
    STEP,
    getChatMessages,
    getChatMessagesOld,
    getParticipant,
    sendMessage,
    sendFile,
    getInfo,
    delItem,
    restore,
    addUserToChat,
    deleteUserFromChat,
    addChatToFavorites,
    removeChatFromFavorites,
    leaveChat,
    addGroupUsersToDriverChat,
    deleteGroupUsersFromDriverChat,
};
